import { useI18n, usePortfolioData } from "../i18n";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import PortfolioCard from "../components/common/portfolioCard";

const Projects = () => {
  const { user: INFO, seo: SEO, projects: PROJECTS } = usePortfolioData();
  const { t } = useI18n();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentSEO = SEO.find((item) => item.page === "projects");

  const projectGroups = [
    { type: "work", title: t("workProjects") },
    { type: "personal", title: t("personalProjects") },
    { type: "toy", title: t("toyProjects") },
  ];

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${t("projects")} | ${INFO.main.title}`}</title>
        <meta name="description" content={currentSEO.description} />
        <meta name="keywords" content={currentSEO.keywords.join(", ")} />
      </Helmet>

      <div className="page-content">
        <NavBar active="projects" />
        <div className="content-wrapper">
          <div className="page-section">
            <div className="title">{INFO.project.title}</div>

            <div className="subtitle">{INFO.project.description}</div>

            <div className="collection">
              <div className="collection-groups">
                {projectGroups.map((group) => (
                  <React.Fragment key={group.type}>
                    <div className="collection-label">{group.title}</div>
                    {PROJECTS.filter(
                      (project) => project.type === group.type,
                    ).map((project) => (
                      <div className="collection-item" key={project.id}>
                        <PortfolioCard item={project} />
                      </div>
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
          <div className="page-footer">
            <Footer />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Projects;
